import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { OrderMethodsListFilter } from 'pages/OrderMethods/OrderMethodsList';
import qs from 'qs';
import { Method } from 'types/embedded/method';
import { getId } from 'utils';

export type GetOrderMethodsResponse = {
  data: {
    methods: Method[];
  };
};

export const getOrderMethods = async (
  filter: OrderMethodsListFilter,
): Promise<GetOrderMethodsResponse> => {
  const params = qs.stringify(
    {
      country: filter?.country,
      currency: filter.currency,
      direction: filter?.direction,
      customerId: filter?.customerId,
      merchantId: getId(filter?.merchantId),
      language: filter?.language,
      countDeposit: filter?.countDeposit,
      appVersion: filter?.appVersion,
      domain: filter?.domain,
    },
    { arrayFormat: 'indices', encode: false },
  );

  return axios
    .get(`${Resources.OrderMethods}?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
